import React from "react";
import { ConselhosPage } from "./conselhos.page";
import { ConselhosProvider } from "./context/conselhos-context";

export function ConselhosFactory() {
    return (
        <ConselhosProvider>
            <ConselhosPage></ConselhosPage>
        </ConselhosProvider>
    );
}
